export const base = (value: any) => value;

export default base;
